import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { GlobalLoaderService } from '../loading/global-loader.service';
import { SKIP_GLOBAL_LOADER_HEADER } from '../loading/global-loader.constants';

/**
 * Shows the global Lottie loader while any counted HTTP request is in flight.
 * Opt out per request with header {@link SKIP_GLOBAL_LOADER_HEADER}: `true` (stripped before send).
 */
export const globalLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const skipByHeader = req.headers.has(SKIP_GLOBAL_LOADER_HEADER);
  const outbound = skipByHeader
    ? req.clone({ headers: req.headers.delete(SKIP_GLOBAL_LOADER_HEADER) })
    : req;

  if (skipByHeader) {
    return next(outbound);
  }

  const loader = inject(GlobalLoaderService);
  loader.begin();
  return next(outbound).pipe(finalize(() => loader.end()));
};
